import type { Location } from "react-router-dom";

// react-router's "background location" recipe for routes that render as a
// dialog over the page that opened them: the opener stores its location in
// history state, AppRouterProvider renders the page tree at that location
// instead of the real one, and the dialog navigates back to it on close.
interface BackgroundLocationState {
  backgroundLocation?: Location;
}

export const backgroundLocationState = (
  location: Location,
): BackgroundLocationState => ({ backgroundLocation: location });

// History state outlives deploys, so the stored value is not trusted: only an
// absolute location is handed to <Routes> and navigate(); anything else falls
// back to "no opener".
const isLocation = (value: unknown): value is Location => {
  const candidate = value as Partial<Location> | null | undefined;
  return (
    typeof candidate?.pathname === "string" &&
    candidate.pathname.startsWith("/") &&
    typeof candidate.search === "string" &&
    typeof candidate.hash === "string"
  );
};

export const getBackgroundLocation = (
  location: Location,
): Location | undefined => {
  const background = (location.state as BackgroundLocationState | null)
    ?.backgroundLocation;
  return isLocation(background) ? background : undefined;
};
